module.exports = __webpack_public_path__ + "img/aguachicoloapan.58c3da9f.jpg";